import { render, staticRenderFns } from "./brand-select.vue?vue&type=template&id=c2afa7ce&"
import script from "./brand-select.vue?vue&type=script&lang=js&"
export * from "./brand-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports